module.exports = __webpack_public_path__ + "media/dogBuck.4ca17d10.wav";